/**
 * ===========================================================
 * TopFrame — fiche produit (phase 2)
 * Fichier : assets/tf-product.js (chargé par sections/main-product.liquid)
 *
 * - Changement de variante : met à jour le prix du bouton
 *   (« Ajouter au panier · 29,99€ ») et le bloc livraison.
 * - <tf-sticky-atc> : barre d'achat flottante avec l'offre multi-posters.
 * - <tf-bundle> : « Complétez votre collection » (3 posters en A3, 1 clic).
 * Aucune dépendance externe (vanilla JS). Utilise publish / subscribe de Dawn.
 * ===========================================================
 */

(function () {
  'use strict';

  if (window.TFProduct) return;

  // ─────────────────────────────────────────
  // OUTILS
  // ─────────────────────────────────────────
  function formatMoney(cents, format) {
    const value = (Number(cents) || 0) / 100;
    const group = (digits, sep) => digits.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const [int, dec] = value.toFixed(2).split('.');
    const fmt = format || '{{amount_with_comma_separator}}€';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_with_comma_separator':
          return group(int, '.') + ',' + dec;
        case 'amount_no_decimals_with_comma_separator':
          return group(String(Math.round(value)), '.');
        case 'amount_no_decimals':
          return group(String(Math.round(value)), ',');
        case 'amount_with_space_separator':
          return group(int, ' ') + ',' + dec;
        case 'amount_with_apostrophe_separator':
          return group(int, "'") + '.' + dec;
        default:
          return group(int, ',') + '.' + dec;
      }
    });
  }

  function normalize(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  // « Poster PNL - Deux Frères » → « Poster PNL – Deux Frères » (comme snippets/tf-title-parts.liquid)
  function titleParts(title) {
    const t = (title || '').replace(/\s[–—]\s/g, ' - ').trim();
    const cut = t.indexOf(' - ');
    if (cut < 0) return { artist: '', album: t };
    return { artist: t.slice(0, cut).replace(/^poster\s+/i, '').trim(), album: t.slice(cut + 3).trim() };
  }

  function fullTitle(title) {
    const parts = titleParts(title);
    return parts.artist ? 'Poster ' + parts.artist + ' – ' + parts.album : parts.album;
  }

  function parseSection(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function canPublish() {
    return typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  function canSubscribe() {
    return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  // Met le tiroir panier et la pastille du panier à jour, sans ouvrir le tiroir
  function updateDrawer(sections) {
    if (!sections) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      const fresh = parseSection(sections['cart-drawer'], '.drawer__inner');
      const current = drawer.querySelector('.drawer__inner');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const source = parseSection(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && source) bubble.innerHTML = source.innerHTML;
    }
  }

  async function fetchCart() {
    const url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    return response.json();
  }

  window.TFProduct = { formatMoney: formatMoney, updateDrawer: updateDrawer, fetchCart: fetchCart };

  // ─────────────────────────────────────────
  // CHANGEMENT DE VARIANTE : prix du bouton, bloc livraison
  // ─────────────────────────────────────────
  if (canSubscribe()) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const data = event && event.data;
      if (!data || !data.variant) return;
      const sectionId = data.sectionId;

      const priceEl = document.querySelector('#ProductSubmitButton-' + sectionId + ' [data-tf-atc-price]');
      if (priceEl) {
        const sticky = document.querySelector('tf-sticky-atc[data-section="' + sectionId + '"]');
        const format = sticky ? sticky.dataset.moneyFormat : null;
        priceEl.textContent = '\u00a0· ' + formatMoney(data.variant.price, format);
      }

      if (data.html) {
        const freshShip = data.html.getElementById('tf-ship-' + sectionId);
        const ship = document.getElementById('tf-ship-' + sectionId);
        if (freshShip && ship) ship.innerHTML = freshShip.innerHTML;
      }
    });
  }

  // ─────────────────────────────────────────
  // BARRE D'ACHAT FLOTTANTE
  // ─────────────────────────────────────────
  class TfStickyAtc extends HTMLElement {
    connectedCallback() {
      // Pas de barre flottante dans la fenêtre « ajout rapide » des listes de posters
      if (this.closest('quick-add-modal, .quick-add-modal')) {
        this.remove();
        return;
      }
      this.section = this.dataset.section;
      this.variantId = this.dataset.variantId;
      this.price = parseInt(this.dataset.price, 10) || 0;
      this.available = this.dataset.available !== 'false';
      this.cart = null;
      this.busy = false;

      this.pill = this.querySelector('[data-tf-pill]');
      this.count = this.querySelector('[data-tf-count]');
      this.lineWrap = this.querySelector('[data-tf-line]');
      this.lineQty = this.querySelector('[data-tf-line-qty]');
      this.fill = this.querySelector('[data-tf-fill]');
      this.msg = this.querySelector('[data-tf-msg]');
      this.row = this.querySelector('[data-tf-row]');

      this.onScroll = this.onScroll.bind(this);
      this.onClick = this.onClick.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.addEventListener('click', this.onClick);

      if (canSubscribe()) {
        this.unsubCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event && event.data;
          if (!data || data.sectionId !== this.section || !data.variant) return;
          this.variantId = String(data.variant.id);
          this.price = data.variant.price;
          this.available = data.variant.available !== false;
          this.render();
        });
      }

      this.refresh();
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.unsubCart) this.unsubCart();
      if (this.unsubVariant) this.unsubVariant();
    }

    get mainButton() {
      return document.getElementById('ProductSubmitButton-' + this.section);
    }

    money(cents) {
      return formatMoney(cents, this.dataset.moneyFormat);
    }

    // Visible dès que le bouton principal passe sous l'en-tête
    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        const button = this.mainButton;
        if (!button) return;
        const header = document.querySelector('.section-header');
        let headerBottom = 0;
        if (header) headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
        const visible = button.getBoundingClientRect().bottom < headerBottom;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }

    async refresh() {
      try {
        this.cart = await fetchCart();
      } catch (error) {
        console.warn('[TopFrame Barre flottante] Lecture du panier impossible :', error);
      }
      this.render();
    }

    currentLine() {
      if (!this.cart || !this.cart.items) return null;
      return this.cart.items.find((item) => String(item.variant_id) === String(this.variantId)) || null;
    }

    render() {
      const n = this.cart ? this.cart.item_count : 0;
      const line = this.currentLine();

      // Phrases et emojis exacts du site de Valentin
      if (this.pill) this.pill.textContent = n >= 3 ? '🏆 -15% débloqué !' : n === 2 ? '✅ -10% débloqué !' : '2 posters = -10%';
      if (this.count) this.count.textContent = n > 3 ? n + ' posters' : n + ' / 3 posters';
      if (this.fill) this.fill.style.width = (Math.min(n, 3) / 3) * 100 + '%';
      if (this.msg) {
        this.msg.textContent =
          n >= 3
            ? '🎉 Félicitations ! Vous bénéficiez de -15% sur votre commande !'
            : n === 2
            ? 'Ajoutez encore 1 poster pour -15% 🔥'
            : 'Ajoutez ' + (2 - n) + ' poster(s) pour débloquer -10% 🔥';
      }
      if (this.lineWrap) {
        this.lineWrap.hidden = !line;
        if (line && this.lineQty) this.lineQty.textContent = '×' + line.quantity;
      }

      if (!this.row) return;
      if (line) {
        this.row.innerHTML =
          '<div class="tf-sticky__qty">' +
          '<button type="button" data-tf-qty="-1" aria-label="Retirer un poster">−</button>' +
          '<span>' + line.quantity + '</span>' +
          '<button type="button" data-tf-qty="1" aria-label="Ajouter un poster">+</button>' +
          '</div>' +
          '<button type="button" class="tf-sticky__btn" data-tf-open>Voir le panier · ' + this.money(this.cart.total_price) + '</button>';
      } else {
        const label = this.available
          ? (window.variantStrings && window.variantStrings.addToCart ? window.variantStrings.addToCart : 'Ajouter au panier') + ' · ' + this.money(this.price)
          : (window.variantStrings && window.variantStrings.soldOut) || 'Épuisé';
        this.row.innerHTML =
          '<button type="button" class="tf-sticky__btn" data-tf-add' + (this.available ? '' : ' disabled') + '>' + label + '</button>';
      }
    }

    async onClick(event) {
      const add = event.target.closest('[data-tf-add]');
      const open = event.target.closest('[data-tf-open]');
      const qty = event.target.closest('[data-tf-qty]');

      if (add) {
        // Même chemin que le bouton de la fiche : Dawn ajoute et ouvre le panier
        const button = this.mainButton;
        if (button && !button.disabled) button.click();
        return;
      }

      if (open) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(open);
        else window.location.href = this.dataset.cartUrl || '/cart';
        return;
      }

      if (qty && !this.busy) {
        const line = this.currentLine();
        if (!line) return;
        const quantity = Math.max(0, line.quantity + parseInt(qty.dataset.tfQty, 10));
        this.busy = true;
        this.classList.add('is-busy');
        try {
          const response = await fetch((this.dataset.changeUrl || '/cart/change') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: line.key,
              quantity: quantity,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'HTTP ' + response.status);
          updateDrawer(data.sections);
          this.cart = data;
          this.render();
          if (canPublish()) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data });
        } catch (error) {
          console.warn('[TopFrame Barre flottante] Modification impossible :', error);
          this.refresh();
        } finally {
          this.busy = false;
          this.classList.remove('is-busy');
        }
      }
    }
  }

  if (!customElements.get('tf-sticky-atc')) customElements.define('tf-sticky-atc', TfStickyAtc);

  // ─────────────────────────────────────────
  // COMPLÉTEZ VOTRE COLLECTION
  // ─────────────────────────────────────────
  class TfBundle extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelector('[data-tf-bundle-items]');
      this.countEl = this.querySelector('[data-tf-bundle-count]');
      this.totalEl = this.querySelector('[data-tf-bundle-total]');
      this.button = this.querySelector('[data-tf-bundle-add]');
      this.error = this.querySelector('.tf-bundle__err');
      this.addEventListener('change', () => this.update());
      if (this.button) this.button.addEventListener('click', () => this.add());
      this.load();
    }

    money(cents) {
      return formatMoney(cents, this.dataset.moneyFormat);
    }

    // Variante « poster » (sans cadre) disponible la moins chère : l'A3
    pickA3(product) {
      const price = function (v) {
        return typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
      };
      const variants = (product.variants || []).filter(function (v) {
        if (v.available === false) return false;
        const opts = [v.option1, v.option2, v.option3].map(function (o) { return (o || '').toLowerCase(); });
        return opts.indexOf('sans cadre') !== -1;
      });
      if (!variants.length) return null;
      const best = variants.reduce(function (a, b) { return price(b) < price(a) ? b : a; });
      return { variant: best, price: price(best) };
    }

    async load() {
      try {
        const url =
          this.dataset.url + '.json?limit=10&intent=related&product_id=' + encodeURIComponent(this.dataset.productId);
        const data = await fetch(url).then(function (r) { return r.json(); });
        const artist = normalize(this.dataset.artist);
        const same = [];
        const others = [];
        (data.products || []).forEach((product) => {
          if (String(product.id) === String(this.dataset.productId)) return;
          const a3 = this.pickA3(product);
          if (!a3) return;
          const entry = { product: product, variant: a3.variant, price: a3.price };
          if (artist && normalize(product.title).includes(artist)) same.push(entry);
          else others.push(entry);
        });
        const picks = same.concat(others).slice(0, 2);
        if (!picks.length) return;

        picks.forEach((entry) => {
          const image = entry.product.featured_image
            ? String(entry.product.featured_image.src || entry.product.featured_image)
            : '';
          const src = image ? image + (image.indexOf('?') === -1 ? '?' : '&') + 'width=400' : '';
          const label = document.createElement('label');
          label.className = 'tf-bi';
          label.innerHTML =
            '<input type="checkbox" class="tf-bi__in" checked data-variant-id="' + entry.variant.id + '" data-price="' + entry.price + '">' +
            '<span class="tf-bi__ck" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
            (src ? '<img class="tf-bi__img" src="' + src + '" width="54" height="66" loading="lazy" alt="">' : '') +
            '<span class="tf-bi__t"><b></b><span>A3 29,7 × 42 cm</span></span>' +
            '<span class="tf-bi__p">' + this.money(entry.price) + '</span>';
          label.querySelector('.tf-bi__t b').textContent = fullTitle(entry.product.title);
          this.items.appendChild(label);
        });

        const artistEl = this.querySelector('[data-tf-bundle-artist]');
        if (artistEl && same.length >= 2 && this.dataset.artist) artistEl.textContent = ' ' + this.dataset.artist;
        this.update();
        this.hidden = false;
      } catch (error) {
        console.warn('[TopFrame Collection] Chargement impossible :', error);
      }
    }

    checked() {
      return Array.from(this.querySelectorAll('.tf-bi__in:checked'));
    }

    update() {
      const boxes = this.checked();
      const count = boxes.length;
      const subtotal = boxes.reduce(function (sum, box) { return sum + (parseInt(box.dataset.price, 10) || 0); }, 0);
      const rate = count >= 3 ? 0.15 : count === 2 ? 0.1 : 0;
      // Comme Shopify : la remise est arrondie au centime inférieur (ex. 3 × 29,99€ à -15% = 76,48€)
      const total = subtotal - Math.floor(subtotal * rate + 1e-9);
      if (this.countEl) {
        this.countEl.innerHTML =
          count + ' poster' + (count > 1 ? 's' : '') +
          (rate ? ' · <span class="tf-bundle__save">vous économisez ' + this.money(subtotal - total) + '</span>' : '');
      }
      if (this.totalEl) this.totalEl.textContent = this.money(total);
      if (this.button) {
        this.button.disabled = count === 0;
        this.button.textContent =
          count === 3 ? 'Ajouter les 3 au panier' : count === 2 ? 'Ajouter les 2 au panier' : 'Ajouter au panier';
      }
    }

    async add() {
      const boxes = this.checked();
      if (!boxes.length || this.button.disabled) return;
      const label = this.button.textContent;
      this.button.disabled = true;
      this.button.textContent = 'Ajout…';
      if (this.error) this.error.textContent = '';
      try {
        const items = boxes.map(function (box) { return { id: Number(box.dataset.variantId), quantity: 1 }; });
        if (window.TFCart) {
          // V6-V7 : le panier s'ouvre tout de suite et montre les posters cochés aussitôt (assets/tf-cart-suggestions.js)
          const lines = boxes.map(function (box) {
            const row = box.closest('.tf-bi');
            const img = row && row.querySelector('img');
            const name = row && row.querySelector('.tf-bi__t b');
            const price = row && row.querySelector('.tf-bi__p');
            return {
              title: name ? name.textContent.trim() : '',
              detail: 'Poster · Petit (A3) · 29,7 × 42 cm',
              price: price ? price.textContent.trim() : '',
              img: img ? img.currentSrc || img.src : '',
            };
          });
          await window.TFCart.add(items, this.button, lines);
        } else {
          const response = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'HTTP ' + response.status);
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          if (canPublish()) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data });
        }
      } catch (error) {
        console.warn('[TopFrame Collection] Ajout impossible :', error);
        if (this.error) this.error.textContent = 'Ajout impossible pour le moment, merci de réessayer.';
      } finally {
        this.button.textContent = label;
        this.update();
      }
    }
  }

  if (!customElements.get('tf-bundle')) customElements.define('tf-bundle', TfBundle);

  // ─────────────────────────────────────────
  // V5 : GALERIE (téléphone) — compteur « 1 / 6 » sur la photo et points dessous, comme la maquette
  // ─────────────────────────────────────────
  function initGallery(list) {
    if (!list || list.dataset.tfDots) return;
    list.dataset.tfDots = '1';
    const holder = list.closest('slider-component') || list.parentElement;
    const counter = document.createElement('span');
    counter.className = 'tf-gcount';
    counter.setAttribute('aria-hidden', 'true');
    const dots = document.createElement('div');
    dots.className = 'tf-gdots';
    holder.appendChild(counter);
    holder.insertAdjacentElement('afterend', dots);

    const visible = function () {
      return Array.from(list.querySelectorAll('.product__media-item')).filter(function (el) {
        return el.offsetWidth > 0;
      });
    };

    let frame = 0;
    const render = function () {
      frame = 0;
      const items = visible();
      const off = items.length < 2;
      counter.hidden = off;
      dots.hidden = off;
      if (off) return;
      const start = items[0].offsetLeft;
      let current = 0;
      items.forEach(function (el, i) {
        if (Math.abs(el.offsetLeft - start - list.scrollLeft) < el.offsetWidth / 2) current = i;
      });
      counter.textContent = current + 1 + ' / ' + items.length;
      if (dots.children.length !== items.length) {
        dots.innerHTML = '';
        items.forEach(function (el, i) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Photo ' + (i + 1));
          dot.addEventListener('click', function () {
            const target = visible()[i];
            if (target) list.scrollTo({ left: target.offsetLeft - visible()[0].offsetLeft, behavior: 'smooth' });
          });
          dots.appendChild(dot);
        });
      }
      Array.from(dots.children).forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    };
    const schedule = function () {
      if (!frame) frame = requestAnimationFrame(render);
    };

    list.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    new MutationObserver(schedule).observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    render();
  }

  // ─────────────────────────────────────────
  // V5 : NOTE JUDGE.ME — « ★ 5,0 (4) avis » sous le titre et dans le bloc « Avis »
  // Si le thème n'a pas pu la lire (métachamp absent), on la recopie depuis le badge Judge.me de la page.
  // ─────────────────────────────────────────
  function initRating() {
    const badge = document.querySelector('.jdgm-prev-badge[data-number-of-reviews], .jdgm-rev-widg[data-number-of-reviews]');
    if (!badge) return;
    const count = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;
    const average = parseFloat(badge.getAttribute('data-average-rating')) || 0;
    if (count < 1 || !average) return;
    const text = average.toFixed(1).replace('.', ',');
    document.querySelectorAll('[data-tf-rating-avg]').forEach(function (el) {
      if (!el.textContent.trim()) el.textContent = text;
    });
    document.querySelectorAll('[data-tf-rating-count]').forEach(function (el) {
      const value = el.textContent.trim();
      if (!value || value === '0') el.textContent = count;
    });
    document.querySelectorAll('[data-tf-rating], [data-tf-revsum]').forEach(function (el) {
      el.hidden = false;
    });
    document.querySelectorAll('[data-tf-reviews]').forEach(function (el) {
      el.classList.add('has-rating');
    });
  }

  // ─────────────────────────────────────────
  // V5 : « PNL · voir ses 4 posters » — nombre lu sur la recherche (sections/tf-artist-count.liquid),
  // tant que l'artiste n'a pas sa collection (phase 3)
  // ─────────────────────────────────────────
  function initArtistCount() {
    document.querySelectorAll('[data-tf-artist-count-url]').forEach(function (link) {
      fetch(link.getAttribute('data-tf-artist-count-url'))
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          const match = /data-tf-artist-count="(\d+)"/.exec(html || '');
          const count = match ? parseInt(match[1], 10) : 0;
          const target = link.querySelector('[data-tf-artist-n]');
          if (target && count > 1) target.textContent = 'ses ' + count + ' posters';
        })
        .catch(function () {});
    });
  }

  // ─────────────────────────────────────────
  // V6 : en changeant de format (Poster ⇄ Poster encadré), on garde la même taille.
  // Le Grand du poster seul (46x61 ou 49x64) devient le Grand encadré (51x71), et inversement.
  // Sans ça, Dawn demandait une variante qui n'existe pas (« Grand » grisé + 2e « Grand »).
  // Écoute en phase de capture : la bonne taille est cochée avant que Dawn ne lise le choix.
  // ─────────────────────────────────────────
  document.addEventListener(
    'change',
    function (event) {
      const input = event.target;
      if (!input || !input.matches || !input.matches('[data-tf-opt="cadre"] input[type="radio"]')) return;
      const picker = input.closest('.tf-vp') || input.closest('variant-selects') || document;
      const format = /avec/i.test(input.value) ? 'avec' : 'sans';
      const current = picker.querySelector('[data-tf-opt="taille"] input[type="radio"]:checked');
      if (!current || current.getAttribute('data-tf-' + format) === 'true') return;
      const rank = current.getAttribute('data-tf-rank');
      const sizes = picker.querySelectorAll('[data-tf-opt="taille"] input[type="radio"][data-tf-' + format + '="true"]');
      let match = null;
      sizes.forEach(function (size) {
        if (!match && rank !== '0' && size.getAttribute('data-tf-rank') === rank) match = size;
      });
      if (!match && sizes.length) match = sizes[0];
      if (match) match.checked = true;
    },
    true
  );

  // ─────────────────────────────────────────
  // V6 : la page ne remonte plus quand on choisit une variante.
  // Dawn (assets/media-gallery.js, setActiveMedia) fait défiler la fenêtre jusqu'à la photo de la
  // variante. La photo change toujours (en haut de la fiche), mais la page reste où elle est.
  // ─────────────────────────────────────────
  (function keepScrollOnVariantChange() {
    let blockUntil = 0;
    const nativeScrollTo = window.scrollTo.bind(window);
    window.scrollTo = function () {
      if (Date.now() < blockUntil) return;
      return nativeScrollTo.apply(window, arguments);
    };
    const patch = function () {
      const Gallery = customElements.get('media-gallery');
      if (!Gallery || Gallery.prototype.tfKeepScroll) return;
      const original = Gallery.prototype.setActiveMedia;
      Gallery.prototype.setActiveMedia = function () {
        blockUntil = Date.now() + 600;
        return original.apply(this, arguments);
      };
      Gallery.prototype.tfKeepScroll = true;
    };
    if (customElements.get('media-gallery')) patch();
    else customElements.whenDefined('media-gallery').then(patch);
  })();

  function initV5() {
    document.querySelectorAll('.product__media-wrapper .product__media-list').forEach(initGallery);
    initRating();
    initArtistCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV5);
  } else {
    initV5();
  }
})();
